import React, { useEffect, useState } from "react";
import MapComponent from "./mapComponent";
import {
  GetSupplierSalesLocationRequest,
  GetSupplierSalesLocationResponse,
  GetSupplierSalesLocationResponseDATA,
} from "../../models/map.model";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { GetSupplierSalesLocation } from "../../services/map.Service";
import { ApiResultModel } from "../../models/common.model";
import { Formik } from "formik";
import { CacheProvider, ThemeProvider } from "@emotion/react";
import Autocomplate from "../../components/dropdown/Autocomplate";
import { GetStatusResponse } from "../../models/basicInformation.model";
import createCache from "@emotion/cache";
import rtlPlugin from "stylis-plugin-rtl";
import { prefixer } from "stylis";
import { createTheme } from "@mui/material/styles";
import { SUPPLIERIDS, TREE_MAP } from "../../config/cacheKey";
import { GetSuppliers } from "../../services/basicInformation.service";
import { Box, Button, FormControl, Tooltip } from "@mui/material";
import DatePickerComponents from "../../components/datePicker/DatePickerComponents";
import { convertToLocalDateTime } from "../../utility/dateUtility";
import MenuIcon from "@mui/icons-material/Menu";
import styled from "styled-components";
import Layout, {
  Root,
  getHeader,
  getDrawerSidebar,
  getSidebarTrigger,
  getSidebarContent,
  getCollapseBtn,
  getContent,
} from "@mui-treasury/layout";
import MapSideMenu from "./mapSideMenu";
import Toolbar from "@material-ui/core/Toolbar";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

const Header = getHeader(styled);
const DrawerSidebar = getDrawerSidebar(styled);
const SidebarTrigger = getSidebarTrigger(styled);
const SidebarContent = getSidebarContent(styled);
const CollapseBtn = getCollapseBtn(styled);
const Content = getContent(styled);

const scheme = Layout();
scheme.configureHeader((builder) => {
  builder.create("whatever_id").registerConfig("xs", {
    position: "sticky",
  });
});
// const location = useLocation();
export default function BodyMap() {
  //side test
  const [menuSide, setMenuSide] = useState<boolean>();
  scheme.configureEdgeSidebar((builder) => {
    builder
      .create("primarySidebar", { anchor: "left" })
      .registerTemporaryConfig("xs", {
        // anchor: 'left',
        width: "auto", // 'auto' is only valid for temporary variant
      })
      .registerPermanentConfig("xs", {
        width: 450, // px, (%, rem, em is compatible)
        collapsible: true,
        collapsedWidth: 67,
      });

    if (menuSide) {
      builder.hide("primarySidebar", true);
    }
    // or like this
    // builder.hide("primarySidebar", location.pathname === '/')
  });
  const hideSide = () => {
    setMenuSide((prev: any) => !prev);
    setFlyToLoc({ lat: 0, lng: 0 });
  };
  //side test
  const queryClient = useQueryClient();
  const [flyToLoc, setFlyToLoc] = React.useState({
    lat: 0,
    lng: 0,
  });

  const [data, setData] = React.useState<GetSupplierSalesLocationResponse[]>(
    []
  );
  const [weight, setWeight] = React.useState<
    GetSupplierSalesLocationResponseDATA
  >();
  const [valueSupplierIds, setValueSupplierIds] = useState<string[]>([]);
  const [valueSupplier, setValueSupplier] = useState<any[]>([]);
  const [supplierIdsOptions, setSupplierIdsOptions] = React.useState<
    GetStatusResponse[]
  >([]);

  const [valueRequestDate, setValueRequestDate] = React.useState<string>();
  const [requestDate, setRequestDate] = React.useState<
    Date[] | null | undefined
  >(null);
  function changeValueSupplierIds(e: any, value: any) {
    setFlyToLoc({ lat: 0, lng: 0 });
    setValueSupplierIds(e);
    setValueSupplier(value);
  }
  function changeValueRequestDate(e: any) {
    setFlyToLoc({ lat: 0, lng: 0 });
    setValueRequestDate(e.toString().replace(/,/g, " - "));
    setRequestDate(e);
  }
  const fillData = (filterData: GetSupplierSalesLocationRequest) => {
    let filter = generateFilter(filterData);
    GetSupplierSalesLocationMutate(filter);
  };
  useEffect(() => {
    let request = new GetSupplierSalesLocationRequest();
    fillData(request);
  }, []);
  const generateFilter = (filterData: GetSupplierSalesLocationRequest) => {
    let request = new GetSupplierSalesLocationRequest();
    request.fromDate = filterData.fromDate;
    request.toDate = filterData.toDate;
    request.supplierIds = filterData.supplierIds;

    return request;
  };
  //service
  useQuery<GetStatusResponse[]>(SUPPLIERIDS, GetSuppliers, {
    onSuccess(data) {
      setSupplierIdsOptions(data);
    },
  });
  const {
    mutateAsync: GetSupplierSalesLocationMutate,
    isLoading: isMutate,
  } = useMutation(GetSupplierSalesLocation, {
    onSuccess: (
      result: ApiResultModel<GetSupplierSalesLocationResponseDATA>
    ) => {
      if (result) {
        setData(result.data.data!);
        setWeight(result.data);
        queryClient.setQueryData(TREE_MAP, result.data.tree);
      }
    },
  });
  const theme = createTheme({
    direction: "rtl", // Both here and <body dir="rtl">
  });
  const cacheRtl = createCache({
    key: "muirtl",
    stylisPlugins: [prefixer, rtlPlugin],
  });
  let points = [] as any;

  data?.map((item: any) => {
    // let findedItem = props.panelTabs.tabKeys?.find((z: any) => z == item.key);
    // if (findedItem != undefined) {
    points.push([item.lat, item.lng, item.weight]);
    // }
  });
  if (isMutate) {
    return <></>;
  } else {
    return (
      <Root scheme={scheme}>
        <>
          <Box sx={{ flexGrow: 1, paddingBottom: "50px" }}>
            <Content>
              {/* <Container maxWidth="sm"> */}
              <Formik
                initialValues={GetSupplierSalesLocationRequest}
                onSubmit={(values: any) => {
                  setFlyToLoc({ lat: 0, lng: 0 });
                  if (
                    requestDate != null &&
                    (requestDate[0] != undefined || requestDate[1] != undefined)
                  ) {
                    values.fromDate = convertToLocalDateTime(
                      Number(requestDate[0])
                    );
                    if (requestDate.length > 1) {
                      values.toDate = convertToLocalDateTime(
                        Number(requestDate[1])
                      );
                      // } else {
                      //   values.toDate = convertToLocalDateTime(
                      //     Number(requestDate[0])
                      //   );
                    }
                  } else {
                    values.fromDate = undefined;
                    values.toDate = undefined;
                  }
                  values.supplierIds = valueSupplierIds;
                  fillData(values);
                }}
                onChange={() => {
                  setFlyToLoc({ lat: 0, lng: 0 });
                }}
              >
                {({ handleSubmit, handleChange, values }) => (
                  <form onSubmit={handleSubmit} onChange={handleChange}>
                    <div className="row" style={{ paddingBottom: " 20px " }}>
                      <div
                        className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12"
                        style={{ margin: " 1vh" }}
                      >
                        <CacheProvider value={cacheRtl}>
                          <ThemeProvider theme={theme}>
                            <div>
                              <Autocomplate
                                id="supplierIds"
                                name="supplierIds"
                                value={valueSupplierIds}
                                label="پذیرنده"
                                options={supplierIdsOptions}
                                onChange={changeValueSupplierIds}
                                changeMultiSelect={changeValueSupplierIds}
                                responseValue={valueSupplier}
                              />
                            </div>
                          </ThemeProvider>
                        </CacheProvider>
                      </div>
                      <div
                        className="col-4  col-lg-3 col-md-3"
                        style={{ marginTop: "1vh", zIndex: 1100 }}
                      >
                        <FormControl fullWidth className="shadowDatepicker">
                          <DatePickerComponents
                            valueArray={requestDate}
                            // value={new Date(valueRequestDateFrom!)}
                            label={" تاریخ درخواست "}
                            // onChange={(newValue: any) => {
                            //   setRequestDateFrom(newValue);
                            // }}
                            onChange={changeValueRequestDate}
                            range={true}
                          />
                        </FormControl>
                      </div>
                      <div
                        className=" col-4  col-lg-2 col-md-3  butFilter"
                        style={{ marginTop: "1vh" }}
                      >
                        <Button
                          fullWidth
                          variant="contained"
                          type="submit"
                          className="btnForm SuccessDefault  "
                        >
                          فیلتر
                        </Button>
                      </div>
                      {/* <div
                        className=" col-2  col-lg-3 col-md-2  butFilter  "
                        style={{ marginTop: "2vh", textAlign: "end" }}
                      >
                        <Tooltip title="نمایش اطلاعات">
                          <MenuIcon
                            className="cursorPointer"
                            style={{
                              color: "#273C51",
                              left: "0",
                            }}
                            onClick={hideSide}
                          />
                        </Tooltip>
                      </div> */}
                    </div>
                  </form>
                )}
              </Formik>

              <MapComponent
                data={data}
                points={points}
                weight={weight}
                flyToLoc={flyToLoc}
              />
              {/* </Container> */}
            </Content>
            <DrawerSidebar sidebarId="primarySidebar">
              <SidebarContent>
                <MapSideMenu
                  setMenuSide={setMenuSide}
                  setFlyToLoc={setFlyToLoc}
                  // child={<CollapseBtn />}
                />
              </SidebarContent>
            </DrawerSidebar>
            <Tooltip title="نمایش اطلاعات">
              <div className="cursorPointer fixedMenuSide" onClick={hideSide}>
                <ArrowForwardIosIcon
                  style={{
                    color: "#273C51",
                    // marginBottom: "40px",
                    direction: "ltr",
                    width: "3em !important",
                    height: "4em !important",
                    zIndex: 102,
                  }}
                />
              </div>
            </Tooltip>
          </Box>
        </>
      </Root>
    );
  }
}
